export default {
  num: {
    name: "序号",
    attr: "num",
    value: "",
    isHide: false,
    isReadonly: false,
    sort: 1,
    rules: [
      { required: true, message: "请选择", trigger: "blur" },
    ],
    configs: {
      type: "swim",
      change: "onChangeSwim",
      placeholder: "请选择",
      selData: [{ label: "选项一", value: 1 }],
    },
  },
  course_name: {
    name: "课程名称",
    attr: "course_name",
    value: "",
    isHide: false,
    isReadonly: false,
    sort: 1,
    rules: [
      { required: true, message: "请输入", trigger: "blur" },
    ],
    configs: {
      type: "device",
      placeholder: "请输入",
    },
  },
  status_name: {
    name: "状态",
    attr: "status_name",
    value: "",
    isHide: false,
    isReadonly: false,
    sort: 1,
    rules: [
      { required: true, message: "请输入", trigger: "blur" },
    ],
    configs: {
      type: "sensor",
      placeholder: "请输入",
    },
  },
  error_message: {
    name: "错误信息",
    attr: "error_message",
    value: "",
    isHide: false,
    isReadonly: false,
    sort: 1,
    rules: [
      { required: true, message: "请输入", trigger: "blur" },
    ],
    configs: {
      type: "sensor",
      placeholder: "请输入",
    },
  },
  created_at: {
    name: "更新时间",
    attr: "created_at",
    value: "",
    isHide: false,
    isReadonly: false,
    sort: 1,
    rules: [
      { required: true, message: "请输入", trigger: "blur" },
    ],
    configs: {
      type: "sensor",
      placeholder: "请输入",
    },
  },
};
